import { Component, Input, ViewEncapsulation } from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';

@Component({
  standalone: true,
  selector: 'email-margin',
  template: `<table cellspacing="0" cellpadding="0" border="0">
    <tr>
      <td [attr.height]="height + 'px'" [style.lineHeight.px]="height">&nbsp;</td>
    </tr>
  </table>`,
  encapsulation: ViewEncapsulation.None,
  hostDirectives: [SsrMarkToUnwrapDirective],
})
export class EmailMarginComponent {
  @Input({ required: true }) public height: number;
}
